import React from 'react';
import { LazySection } from './LazySection';
export function Transformacion() {
  return <LazySection className="bg-cream !py-[80px] md:!py-[100px]" data-id="element-379">
      <div className="container-wide" data-id="element-380">
        <div className="text-center" data-id="element-381">
          <span className="eyebrow" data-id="element-382">Lo que realmente cambia</span>
        </div>
        <h2 className="text-[clamp(32px,4.8vw,46px)] text-center mb-4" data-id="element-383">
          Cuando separás <em data-id="element-384">lo tuyo</em> de <em data-id="element-385">lo heredado</em>…
        </h2>
        <p className="text-center text-ink-soft text-[17px] max-w-[660px] mx-auto mb-[50px]" data-id="element-386">
          No se trata de que todo se arregle mágicamente. Se trata de que, por
          primera vez, podés ver qué estás eligiendo vos y qué estás
          obedeciendo.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[960px] mx-auto" data-id="element-387">
          {[{
          before: 'Repetir relaciones que lastiman',
          after: 'Ver el <strong>patrón</strong> antes de entrar y elegir distinto.'
        }, {
          before: 'Sentir culpa cuando te va bien',
          after: 'Recibir amor y logros <strong>sin sentir que no lo merecés</strong>.'
        }, {
          before: 'Cargar un peso sin saber por qué',
          after: 'Distinguir tus emociones y <strong>soltar las que no son tuyas</strong>.'
        }, {
          before: 'Autosabotearte sin entender',
          after: 'Identificar el <strong>origen</strong> del freno y desactivarlo.'
        }, {
          before: 'Transmitir a tus hijos lo mismo',
          after: 'Ser la generación que <strong>corta el ciclo</strong> definitivamente.'
        }, {
          before: 'Mirarte y ver a tu madre',
          after: 'Mirarte y verte a vos, <strong>escribiendo tu propia historia</strong>.'
        }].map((item, i) => <div key={i} className="bg-white rounded-[14px] p-6 md:px-6 md:py-6 border-l-[3px] border-l-gold shadow-sm" data-id="element-388">
              <div className="text-[13px] text-ink-soft mb-2 line-through opacity-55" data-id="element-389">
                {item.before}
              </div>
              <div className="font-serif text-[17px] text-ink leading-[1.4]" dangerouslySetInnerHTML={{
            __html: item.after
          }} data-id="element-390" />
            </div>)}
        </div>
      </div>
    </LazySection>;
}